import View, {NotificationsOutletProps as _NotificationsOutletProps} from "./notifications-outlet-view";
import {useCallback, useState} from "react";

export interface NotificationsOutletProps extends Omit<_NotificationsOutletProps, "targetRef"|"target"> {

}
function NotificationsOutlet(props: NotificationsOutletProps) {
  const [target,setTarget] = useState<HTMLDivElement|undefined|null>(undefined);
  const notificationsRef = useCallback((node: HTMLDivElement|undefined|null) => {
      setTarget(node);
  }, []);
  return <View targetRef={notificationsRef} target={target} {...props} />
}
export default NotificationsOutlet;
